import {useQuery} from "@tanstack/react-query";
const { default: apiClient } = require("lib/api-client");

const getSyncListData = async ({queryKey}) =>{
    const [,{search}] = queryKey;

    const response = await apiClient.post("/api/v1/sync/getDyanamicSyncData",{
        search
    });

    if (response.status !== 200) {
        throw new Error("Error in the fetching data");
    }

    return {
        syncAllData: response?.data?.syncAllData,
        cardCount: response?.data?.cardCount,
        totalCount: response?.data?.totalCount,
    };
};

const getSyncListDataTotalCount = async () => {
    const response = await apiClient.get("/api/v1/sync/getSyncDataTotalCount");

    if (!response || response.status !== 200) {
        throw new Error("Error fetching sync data total count");
    }

    return {
        cardCount: response?.data?.cardCount,
        totalCount: response?.data?.totalCount,
    };
};

export const useGetSyncList = ({search=""}) =>{
    return useQuery({
        queryKey:["getSyncList",{search}],
        queryFn:()=>getSyncListData({queryKey:["getSyncList",{search}]}),
        staleTime: 1 * 60 * 1000,
    });
};


export const useGetSyncListTotalCount = () => {
    return useQuery({
        queryKey: ["getSyncListTotalCount"],
        queryFn: getSyncListDataTotalCount,
        staleTime: 60 * 1000, // 1 minute
    });
};